import React from 'react';
import { AlertCircle, CheckCircle2, Info, XCircle } from 'lucide-react';
import { cn } from '../../utils/cn';
export type AlertVariant = 'info' | 'success' | 'warning' | 'error';
interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: AlertVariant;
  title?: string;
}
export function Alert({
  className,
  variant = 'info',
  title,
  children,
  ...props
}: AlertProps) {
  const variants = {
    info: 'bg-blue-50 dark:bg-blue-900/20 text-blue-800 dark:text-blue-300 border-blue-200 dark:border-blue-800/50',
    success: 'bg-green-50 dark:bg-green-900/20 text-green-800 dark:text-green-300 border-green-200 dark:border-green-800/50',
    warning: 'bg-yellow-50 dark:bg-yellow-900/20 text-yellow-800 dark:text-yellow-300 border-yellow-200 dark:border-yellow-800/50',
    error: 'bg-red-50 dark:bg-red-900/20 text-red-800 dark:text-red-300 border-red-200 dark:border-red-800/50'
  };
  const icons = {
    info: <Info className="h-5 w-5 text-blue-500 dark:text-blue-400" data-id="element-293" />,
    success: <CheckCircle2 className="h-5 w-5 text-green-500 dark:text-green-400" data-id="element-294" />,
    warning: <AlertCircle className="h-5 w-5 text-yellow-500 dark:text-yellow-400" data-id="element-295" />,
    error: <XCircle className="h-5 w-5 text-red-500 dark:text-red-400" data-id="element-296" />
  };
  return <div className={cn('flex p-4 rounded-lg border', variants[variant], className)} {...props} data-id="element-297">
      <div className="flex-shrink-0 mr-3" data-id="element-298">{icons[variant]}</div>
      <div data-id="element-299">
        {title && <h3 className="text-sm font-medium mb-1" data-id="element-300">{title}</h3>}
        <div className="text-sm opacity-90" data-id="element-301">{children}</div>
      </div>
    </div>;
}